module.exports = __webpack_public_path__ + "static/img/autumn_yaocaiPic.3267ae78.png";